import { render } from "./SlipList.vue?vue&type=template&id=41fbee66&scoped=true&ts=true"
import script from "./SlipList.vue?vue&type=script&lang=ts"
export * from "./SlipList.vue?vue&type=script&lang=ts"

import "./SlipList.vue?vue&type=style&index=0&id=41fbee66&scoped=true&lang=css"

import exportComponent from "/frontside/account/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41fbee66"]])

export default __exports__